// import React from 'react';
// import AnchorLink from 'react-anchor-link-smooth-scroll';
// import './style.css';

// const Scrollbar = () => {
//   return (
//     <ul className="smothscroll">
//       <li>
//         <AnchorLink href="#scrool">
//           <i className="far fa-arrow-up"></i>
//         </AnchorLink>
//       </li>
//     </ul>
//   );
// };

// export default Scrollbar;
import React, { useState, useEffect } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './style.css';

const Scrollbar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <ul className={`smothscroll ${isVisible ? 'show' : 'hide'}`}>
      <li>
        <AnchorLink href="#scrool">
          <i className="far fa-arrow-up"></i>
        </AnchorLink>
      </li>
    </ul>
  );
};

export default Scrollbar;
